function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 272.383 272.383",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M223.214,152.723h-32.237c16.306-20.152,26.76-47.195,26.76-71.415 C217.737,36.474,181.262,0,136.428,0S55.114,36.474,55.114,81.309c0,24.22,10.454,51.263,26.76,71.415H49.164 c-14.86,0-28.544,7.468-36.599,19.972c-5.673,8.811-6.864,24.242-3.535,45.868l4.259,27.701 c2.246,14.647,15.621,26.118,30.437,26.118h184.928c14.816,0,28.191-11.471,30.442-26.118l4.259-27.701 c3.329-21.626,2.138-37.056-3.535-45.868C251.758,160.191,238.073,152.723,223.214,152.723z M248.342,244.616 c-1.409,9.154-10.427,16.888-19.689,16.888H43.725c-9.263,0-18.281-7.734-19.689-16.888l-4.259-27.701 c-2.828-18.389-2.143-31.998,1.931-38.324c6.043-9.388,16.312-14.99,27.456-14.99h42.838 c12.901,11.988,28.229,19.668,44.421,19.668s31.525-7.68,44.421-19.668h42.37c11.145,0,21.414,5.602,27.456,14.985 c4.079,6.326,4.759,19.94,1.931,38.324L248.342,244.616z M207.408,81.309c0,24.438-12.276,52.786-30.263,71.415 c-1.86,1.925-3.775,3.737-5.749,5.439c-2.29,1.974-4.64,3.813-7.065,5.439c-8.686,5.831-18.145,9.339-27.908,9.339 s-19.216-3.508-27.902-9.339c-2.426-1.626-4.775-3.465-7.065-5.439c-1.974-1.702-3.889-3.514-5.749-5.439 c-17.987-18.629-30.263-46.972-30.263-71.415c0-39.14,31.84-70.985,70.985-70.985S207.408,42.169,207.408,81.309z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankUser);
export default __webpack_public_path__ + "static/media/blank-user.2e972ec76901b8d773a0f41eecea00c4.svg";
export { ForwardRef as ReactComponent };